import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleLeft,
  faArrowCircleRight,
  faHomeLgAlt,
  faSackDollar,
  faBuilding,
  faUser,
  faMoneyCheckEditAlt,
  faUsers,
  faTools,
  faFilesMedical,
  faCalculator,
  faBars,
} from "@fortawesome/pro-light-svg-icons";
import { ROUTES } from "../../utils";
import { NavLink, Link } from "react-router-dom";
import { AddToolTip } from "../../components";

const menuItems = [
  {
    label: "Home",
    icon: faHomeLgAlt,
    route: "/home",
    childRoutes: [],
  },
  {
    label: "Plans",
    icon: faSackDollar,
    route: "/plans",
    childRoutes: [],
  },
  {
    label: "Company",
    icon: faBuilding,
    route: "/company",
    childRoutes: [],
  },
  {
    label: "Employees",
    icon: faUser,
    route: "/employees",
    childRoutes: [],
  },
  {
    label: "Eligibility",
    icon: faMoneyCheckEditAlt,
    route: "/eligibility",
    childRoutes: [],
  },
  {
    label: "Enrollment",
    icon: faUsers,
    route: "/enrollment",
    childRoutes: [],
  },
  {
    label: "Payroll",
    icon: faSackDollar,
    route: "/payroll",
    childRoutes: [],
  },
  {
    label: "Maintenance",
    icon: faTools,
    route: "/maintenance",
    childRoutes: [],
  },
  {
    label: "Mapper",
    icon: faFilesMedical,
    route: "/mapper",
    childRoutes: [],
  },
  {
    label: "Calculator",
    icon: faCalculator,
    route: "/calculator",
    childRoutes: [],
  },
];

const SideBarContentNew = ({ onClickLeft, onClickRight }) => {
  const CoreIcon = (
    <span className="core-icon">
      <Image src={`/assets/icons/svg/core.svg`} width="60px" height="100%" />
    </span>
  );
  return (
    <div className="d-flex sidebar-content flex-column justify-content-between py-4 pl-3">
      <Col className="minimized-content flex-column">
        <div className="ml-auto mb-3">
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: "white" }}
            icon={faBars}
          />
        </div>
        {menuItems.map((e, i) => {
          return (
            <NavLink to={e.route} className="ml-auto mb-3">
              <FontAwesomeIcon style={{ fontSize: "20px" }} icon={e.icon} />
            </NavLink>
          );
        })}

        {/* <div className="arrow-icon-right pointer">
          <FontAwesomeIcon icon={faArrowCircleRight} onClick={onClickRight} />
        </div> */}
        {/* <Image className="ml-auto mb-3" src={`/assets/icons/svg/core-white-small.svg`} width={60} style={{ alignSelf: "center", height: "20px" }} /> */}
      </Col>
      {/* <Col className="maximized-content">
        <div>{CoreIcon}</div>
      </Col> */}
      <Col className="maximized-content  h-1 flex-column">
        {menuItems.map((e, i) => {
          return (
            <Row className="mt-10">
              <NavLink to={e.route} className="d-flex mb-3 w-100">
                <Col md={3}>
                  <FontAwesomeIcon style={{ fontSize: "20px" }} icon={e.icon} />
                </Col>
                <Col md={9} style={{ fontSize: "16px" }}>
                  {e.label}
                </Col>
              </NavLink>
            </Row>
          );
        })}

        <div className="mt-auto" style={{ fontSize: "14px" }}>
          Powered By{" "}
          <Image
            src={`/assets/icons/svg/core-white-small.svg`}
            width={60}
            style={{ alignSelf: "center" }}
          />
          {/* <div className="arrow-icon-left pointer">
            <FontAwesomeIcon  icon={faArrowCircleLeft} onClick={onClickLeft} />
          </div> */}
        </div>
      </Col>
    </div>
  );
};

export default SideBarContentNew;
